import type { AxiosError, AxiosInstance } from "axios"
import { history } from "../redux/Store"

export function errorInterceptor(instance: AxiosInstance) {
  instance.interceptors.response.use(
    (response) => {
      return response
    },
    (error: AxiosError) => {
      if (error?.response?.status === 401) {
        history.push("/unauthorized")
      }
    }
  )
}
